import { render, staticRenderFns } from "./SeverityProgressBar.vue?vue&type=template&id=6f2e636a&"
import script from "./SeverityProgressBar.vue?vue&type=script&lang=js&"
export * from "./SeverityProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2e636a')) {
      api.createRecord('6f2e636a', component.options)
    } else {
      api.reload('6f2e636a', component.options)
    }
    module.hot.accept("./SeverityProgressBar.vue?vue&type=template&id=6f2e636a&", function () {
      api.rerender('6f2e636a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/SeverityProgressBar.vue"
export default component.exports